import { range } from 'lodash';
import React from 'react';
import styles from './ScaleInput.module.scss';

function ScaleInput(props) {
    const { className, value, onChange, min = 1, max = 5, IconON, IconOFF } = props;

    return (
        <div className={[className, styles.ScaleInput].join(' ')}>
            {range(min, max + 1).map((i) => {
                if (value >= i) {
                    return <IconON key={i} onClick={() => onChange(i)} />;
                } else {
                    return <IconOFF key={i} onClick={() => onChange(i)} />;
                }
            })}
        </div>
    );
}

export default ScaleInput;
